import * as React from 'react';
import { red } from '../../consts/variables';
import loadable from '@loadable/component';

const CustomSelect = loadable(() => import('../CustomSelect/CustomSelect'));

const styles = {
    wrapper: {
        margin: '12px 0px 0px',
    },
};

interface IProps {
    onChange: React.EventHandler<any>;
    value: string;
    isValid: boolean;
    options: { label: string; value: string }[];
    instanceId: string;
}

export const WelcomePageDropdown = (props: IProps) => {
    const onChange = (input) => {
        const selectedOption = props.options.filter((val) => val.value === input.value).shift();
        props.onChange(selectedOption);
    };
    const style = props.isValid ? styles.wrapper : { ...styles.wrapper, borderColor: red };
    return (
        <CustomSelect
            style={style}
            clearable={false}
            options={props.options}
            value={props.value}
            onChange={onChange}
        />
    );
};
